import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { TOOL_IDS } from '../../lib/agents/firestore-schema';
import { Calculator, BarChart3, TrendingUp, FileSpreadsheet } from 'lucide-react';

const TOOLS = [
  { id: TOOL_IDS.PLACEHOLDER, path: 'placeholder', label: 'Placeholder Tool', description: 'Sample tool for testing the framework.', icon: FileSpreadsheet },
  { id: TOOL_IDS.FINANCIAL_NEED_ANALYSIS, path: 'financial-need-analysis', label: 'Financial Need Analysis', description: 'Analyze client financial needs and generate a shareable report.', icon: Calculator },
  { id: TOOL_IDS.INVESTMENT_COMPARISON, path: 'investment-comparison', label: 'Investment Comparison', description: 'Compare different investment strategies side by side.', icon: BarChart3 },
  { id: TOOL_IDS.IMO_COMPENSATION, path: 'imo-compensation', label: 'IMO Compensation & Promotion', description: 'Promotion path, commission levels, and activity-to-result estimates with visualizations.', icon: TrendingUp },
];

export default function AgentsDashboard() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">Training Tools</h1>
      <p className="text-muted-foreground mb-6">
        Select a tool to practice and generate reports. Usage is tracked for training purposes.
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        {TOOLS.map(({ path, label, description, icon: Icon }) => (
          <Link key={path} to={`/agents/${path}`}>
            <Card className="h-full hover:border-primary hover:shadow-md transition-all cursor-pointer">
              <CardHeader className="flex flex-row items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <CardTitle className="text-lg">{label}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
